// Banka Hesap Tanımlama (/bank-account-management). Kayıtlı değerler
// yazıldığı gibi gösterilir.
const bankAccounts = {
  page: {
    title: 'Banka Hesapları',
    subtitle: 'Firma hesaplarını, IBAN bilgilerini ve ödeme / kesinti tanımlarını yönetin.',
  },
  actions: {
    add: 'Yeni Hesap Ekle',
  },
  stats: {
    total: 'Kayıtlı Hesap',
    totalShort: 'Hesap',
    active: 'Aktif',
    activeShort: 'Aktif',
    passive: 'Pasif / Kapalı',
    passiveShort: 'Pasif',
    pending: 'Beklemede',
    pendingShort: 'Bekleyen',
    share: 'Hesapların %{{percent}}’i',
  },
  toolbar: {
    search: 'Firma, şube, IBAN veya açıklama ile ara…',
    searchShort: 'Hesap ara…',
    status: 'Durum',
    groups: {
      all: 'Tümü',
      active: 'Aktif',
      passive: 'Pasif',
      pending: 'Beklemede',
    },
  },
  fields: {
    firma: 'Firma',
    sube: 'Şube',
    hesapNo: 'Hesap No / IBAN',
    dosyaAciklama: 'Dosya Açıklaması',
    odemeKesinti: 'Ödeme / Kesinti',
    odemeTuru: 'Ödeme Türü',
    odemeAciklama: 'Ödeme Açıklaması',
    odemeDonemi: 'Ödeme Dönemi',
    durum: 'Durum',
  },
  table: {
    listLabel: 'Kayıtlı banka hesapları',
    empty: 'Filtrelere uygun hesap bulunamadı',
    none: 'Henüz kayıtlı hesap bulunmamaktadır.',
    rangeOf: '/ {{total}} hesap',
    ofTotal: 'toplam {{total}} hesap içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili hesap',
    heading: 'Hesap',
    edit: 'Düzenle',
  },
  form: {
    newTitle: 'Yeni Hesap',
    editTitle: 'Hesap Düzenle',
    subtitle: 'Tüm alanların doldurulması zorunludur.',
    sections: {
      company: 'Firma ve hesap',
      payment: 'Ödeme bilgileri',
      status: 'Durum',
    },
    placeholder: '{{field}} giriniz',
    odemeAciklamaHint: 'Ödeme türü “Diğer” ise açıklayın.',
    required: 'Bu alan zorunludur',
    cancel: 'İptal',
    save: 'Kaydet',
    update: 'Güncelle',
    saving: 'Kaydediliyor…',
  },
  toast: {
    loadError: 'Hesaplar yüklenirken hata oluştu: {{message}}',
    fillAll: 'Lütfen tüm alanları doldurunuz.',
    added: 'Kayıt başarıyla eklendi!',
    updated: 'Kayıt başarıyla güncellendi!',
    saveError: 'Bir hata oluştu: {{message}}',
    updateError: 'Güncelleme sırasında hata oluştu: {{message}}',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default bankAccounts;
